import { render, staticRenderFns } from "./quickReplyManage.vue?vue&type=template&id=aeea35a8&scoped=true"
import script from "./quickReplyManage.vue?vue&type=script&lang=ts"
export * from "./quickReplyManage.vue?vue&type=script&lang=ts"
import style0 from "./quickReplyManage.vue?vue&type=style&index=0&id=aeea35a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeea35a8",
  null
  
)

export default component.exports